import { render, staticRenderFns } from "./TemplteEmailAddNew.vue?vue&type=template&id=0cd4c83a&scoped=true&"
import script from "./TemplteEmailAddNew.vue?vue&type=script&lang=js&"
export * from "./TemplteEmailAddNew.vue?vue&type=script&lang=js&"
import style0 from "./TemplteEmailAddNew.vue?vue&type=style&index=0&id=0cd4c83a&prod&scoped=true&lang=css&"
import style1 from "./TemplteEmailAddNew.vue?vue&type=style&index=1&id=0cd4c83a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd4c83a",
  null
  
)

export default component.exports